module.exports = __webpack_public_path__ + "static/instagram-51c18d16f143a3fd11d7a6fe78b6eefe.jpg";